/* src/app/shared/controls/wizard-control/wizard-step.component.scss */
.wizard-step {
  width: 100%;
}
/*# sourceMappingURL=wizard-step.component-CEVQ2RUE.css.map */
